import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { caseStudies } from '../../../data/caseStudies';
import './CaseStudies.css';
const CaseStudies = () => {
    const caseStudiesSectionRef = useRef(null);
    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px -100px 0px',
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('flipbook-visible');
                }
            });
        }, observerOptions);
        if (caseStudiesSectionRef.current) {
            observer.observe(caseStudiesSectionRef.current);
        }
        return () => observer.disconnect();
    }, []);
    return (_jsx("section", { id: "case-studies", ref: caseStudiesSectionRef, className: "case-studies section flipbook-section", children: _jsxs("div", { className: "container", children: [_jsx("h2", { className: "section-title", children: "Who We've Worked With" }), _jsx("div", { className: "case-studies-grid", children: caseStudies.map((study) => (_jsxs("div", { className: "case-study-card", children: [study.image && (_jsx("div", { className: "case-study-image", children: _jsx("img", { src: study.image, alt: `${study.title} - ${study.category} project screenshot`, loading: "lazy", onError: (e) => {
                                        e.currentTarget.style.display = 'none';
                                    } }) })), _jsxs("div", { className: "case-study-content", children: [_jsx("div", { className: "case-study-category", children: study.category }), _jsx("h3", { children: study.title }), _jsx("p", { children: study.description }), _jsxs("div", { className: "case-study-actions", children: [_jsx("a", { href: study.liveUrl, className: "btn btn-secondary", target: "_blank", rel: "noopener noreferrer", children: "\uD83D\uDD17 Live Website" }), _jsx(Link, { to: `/case-studies/${study.slug}`, className: "btn btn-primary", children: "View Case Study" })] })] })] }, study.id))) })] }) }));
};
export default CaseStudies;
